import { html, nothing } from 'lit';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import utilitySprites from '@salesforce-ux/design-system/assets/icons/utility-sprite/svg/symbols.svg?inline';
import actionSprites from '@salesforce-ux/design-system/assets/icons/action-sprite/svg/symbols.svg?inline';
import standardSprites from '@salesforce-ux/design-system/assets/icons/standard-sprite/svg/symbols.svg?inline';
//import svgSprites from '@salesforce-ux/design-system/assets/icons/svg-sprite/svg/symbols.svg?inline';
/*import utility_sprites from '/node_modules/@salesforce-ux/design-system/assets/icons/utility-sprite/svg/symbols.svg';
import action_sprites from '/node_modules/@salesforce-ux/design-system/assets/icons/action-sprite/svg/symbols.svg';
import standard_sprites from '/node_modules/@salesforce-ux/design-system/assets/icons/standard-sprite/svg/symbols.svg';
import svg_sprites from '../svgs/symbols.svg';*/
export class Icon {
    static { this.SPRITES_MAP = {
        utility: utilitySprites,
        standard: standardSprites,
        action: actionSprites,
        //svg: svgSprites,
    }; }
    static { this.getIconPath = ({ icon = 'apps', sprite = 'utility' }) => {
        if (sprite && Icon.SPRITES_MAP[sprite]) {
            return `${Icon.SPRITES_MAP[sprite]}#${icon}`;
        }
    }; }
    static { this.getSVGIconTag = ({ icon, sprite, classes = [], color }) => {
        const iconPath = icon.startsWith('/') ? icon : this.getIconPath({ icon, sprite });
        return iconPath
            ? html ` <span style="${color ? "color:" + color : ''}" class="${color ? 'slds-current-color' : ''} slds-icon_container"><svg class="${classes?.join(' ')}" aria-hidden="true">${unsafeSVG(`<use xlink:href="${iconPath}"></use>`)}</svg></span>`
            : nothing;
    }; }
}
